<template>
  <el-dialog class="invoice-dialog" :visible="dialogVisible" :append-to-body="true" v-loading="loading" title="" @close="cancel">

    <pt-sub-title title="确认已开票">
    </pt-sub-title>
    <pt-form-item label="发票抬头：" :labelWidth="labelWidth">
      <span v-if="invoice">{{invoice.title}}</span>
    </pt-form-item>
    <pt-form-item label="纳税人识别号：" :labelWidth="labelWidth">
      <span v-if="invoice">{{invoice.taxId}}</span>
    </pt-form-item>
    <pt-form-item label="开票内容：" :labelWidth="labelWidth">
      <span v-if="invoice">{{selectData[0]&&selectData[0].invoiceContent}}</span>
    </pt-form-item>
    <pt-form-item label="上传发票照片：" :labelWidth="labelWidth">
      <template>
        <wt-upload-file :key="uploadKey" :action="uploadApi" class="news-banner-pictrue-upload" :data="picture_params" :img-url="privateResourcesUrl" v-model="form.attachments" name="title">
          <div class="main-color">+添加图片</div>
        </wt-upload-file>
        <div class="gray-color">*建议尺寸：301*255像素；建议分辨率：120dpi；图片格式：.jpg、.png</div>
      </template>
    </pt-form-item>
    <pt-form-item label="快递单号：" :labelWidth="labelWidth">
      <el-input placeholder="请填写快递单号" v-model="form.expressCode"></el-input>
    </pt-form-item>

    <div class="button-div">
      <el-button type="primary" @click="submit">确认</el-button>
      <el-button type="primary" plain @click="cancel">取消</el-button>
    </div>
  </el-dialog>
</template>
<script>
import {
  validate
} from 'utils/validate'
export default {
  name: 'invoice-dialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    ids: {
      type: Array,
      default: () => []
    },
    selectData: {
      type: Array,
      default: () => {}
    }
  },
  computed: {
    invoice () {
      return this.selectData?.[0]?.organization.invoice
    }
  },
  data () {
    return {
      uploadApi: this.$uploadApi,
      picture_params: {
        objectId: this.invoice?.taxId || 0,
        resourceName: 'invoice'
      },
      privateResourcesUrl: this.$privateResourcesUrl,
      labelWidth: '100px',
      loading: false,
      form: {},
      uploadKey: 0
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        // 每次打开弹窗时重置上传组件和表单，避免残留上次的数据
        this.uploadKey++
        this.form = { attachments: [] }
        this.picture_params = {
          objectId: this.invoice?.taxId || 0,
          resourceName: 'invoice'
        }
      }
    }
  },
  methods: {
    submit () {
      validate(this, this.form).then(() => {
        this.loading = true
        let data = {
          ids: [this.selectData?.[0].id],
          taxId: this.invoice.taxId,
          title: this.invoice.title,
          invoiceContent: this.selectData?.[0]?.invoiceContent,
          ...this.form,
          attachments: this.form.attachments&&this.form.attachments.map(url => {
            const urlList = url.split('/')
            return {
              type: 'INVOICE_PICTURE',
              name: urlList[urlList.length - 1],
              ossUrl: url
            }
          })
        }
        this.$store.dispatch('handleInvoice', data).then(res => {
          this.$message.success('操作成功')
          this.loading = false
          this.form = { attachments: [] }
          this.cancel()
          this.$emit('reload')
        }).catch(err => {
          this.loading = false
          this.$message.warning(err || '操作失败')
        })
      })
    },

    cancel () {
      this.$emit('close')
    }

  }
}
</script>
<style lang="less">
.invoice-dialog{
  .el-input,
  // .el-textarea,
  .el-input__inner {
    max-width: 2.8rem;
  }
  .button-div{
    margin-top: 40px;
  }

  .news-banner-pictrue-upload{
      .el-upload--picture-card{
          width: 150px;
          height: 100px;
          display:inline-flex;
          align-items: center;
          justify-content: center;
      }
      .el-upload-list__item{
          .el-upload--picture-card;
          box-sizing:inherit
      }
  }
}

</style>
